module.exports = __webpack_public_path__ + "static/img/s-hw-2.07e53ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s-hw-2.png
// module id = u/U6
// module chunks = 0